import { z } from 'zod';

/**
 * `GET /api/me` — reflects the active session. `workspaceId` is nullable
 * because a fresh Clerk app's session-token template won't have
 * `activeWorkspaceId` set until configured. The frontend treats `null` as
 * "no workspace selected" and routes the user to a workspace-picker (later
 * PR). Future fields (email, displayName, avatarUrl, plan) land via
 * additive ADRs without breaking the wire.
 */
export const MeResponseSchema = z.object({
  userId: z.string().min(1),
  workspaceId: z.string().min(1).nullable(),
});

export type MeResponse = z.infer<typeof MeResponseSchema>;
